(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["promo-carosel"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.promo-carousel').forEach(function (section) {
    var track      = section.querySelector('.promo-carousel__track');
    var slides     = Array.from(section.querySelectorAll('.promo-carousel__slide'));
    var btnPrev    = section.querySelector('.promo-carousel__btn--prev');
    var btnNext    = section.querySelector('.promo-carousel__btn--next');
    var dots       = Array.from(section.querySelectorAll('.promo-carousel__dot'));
    var autoplay   = section.dataset.autoplay === 'true';
    var speed      = parseInt(section.dataset.autoplaySpeed, 10) || 4000;
    var visible    = parseInt(section.dataset.cardsVisible, 10) || 5;
    var total      = slides.length;
    var current    = 0;
    var timer      = null;

    // Set CSS var for slide sizing
    track.style.setProperty('--cards-visible', visible);
    section.querySelector('.promo-carousel__slide') &&
      section.style.setProperty('--cards-visible', visible);
    slides.forEach(function (s) { s.style.setProperty('--cards-visible', visible); });

    function slideWidth() {
      if (!slides[0]) return 0;
      return slides[0].getBoundingClientRect().width + 16;
    }

    function goTo(index) {
      var max = Math.max(0, total - visible);
      current = Math.max(0, Math.min(index, max));
      track.style.transform = 'translateX(-' + (current * slideWidth()) + 'px)';
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
      });
      if (btnPrev) btnPrev.disabled = current === 0;
      if (btnNext) btnNext.disabled = current >= max;
    }

    if (btnPrev) btnPrev.addEventListener('click', function () { goTo(current - 1); resetTimer(); });
    if (btnNext) btnNext.addEventListener('click', function () { goTo(current + 1); resetTimer(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); resetTimer(); });
    });

    function startTimer() {
      if (!autoplay) return;
      timer = setInterval(function () {
        var next = current + 1;
        if (next > Math.max(0, total - visible)) next = 0;
        goTo(next);
      }, speed);
    }
    function resetTimer() {
      clearInterval(timer);
      startTimer();
    }

    goTo(0);
    startTimer();

    window.addEventListener('resize', function () { goTo(current); });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
